// document.addEventListener("DOMContentLoaded", function () {
jQuery(function ($) {
  if ($().selectWoo) {
    $(".single-product__attribute-select").selectWoo({
      minimumResultsForSearch: Infinity,
      width: "100%",
      // placeholder: "Choose an option",
    });
  }
});
